import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import Home from "./components/pages/Home";
import Features from "./components/pages/Features";
import Process from "./components/pages/Process";
import Insights from "./components/pages/Insights";
import Contact from "./components/pages/Contact";
import StructuredData from "./components/StructuredData";
import "./App.css";
import "./components/styles/Transitions.css";
import "./components/styles/HeroSection.css";
import "./components/styles/Navbar.css";
import "./components/styles/Pages.css";

import { init } from '@emailjs/browser';
init("Kc-vHGY1O81C-fuTk");

function AnimatedRoutes() {
  const location = useLocation();

  return (
    <TransitionGroup>
      <CSSTransition
        key={location.key}
        timeout={300}
        classNames="page-transition"
      >
        <Routes location={location}>
          <Route path="/" element={<Home />} />
          <Route path="/features" element={<Features />} />
          <Route path="/process" element={<Process />} />
          <Route path="/insights" element={<Insights />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </CSSTransition>
    </TransitionGroup>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <StructuredData />
        <AnimatedRoutes />
      </div>
    </Router>
  );
}

export default App; 